// extracted by mini-css-extract-plugin
module.exports = {"container":"MiddleSection_container__YgFPq","blue-gradient":"MiddleSection_blue-gradient__9lQxU","gold-gradient-1":"MiddleSection_gold-gradient-1__nGBL_"};